<ng-container *ngIf="sectionName">
  <div class="remark-section__title">
    {{ sectionName | translate }}
  </div>
</ng-container>

<div class="remark-container">
  <ng-content></ng-content>
</div>
